<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Aguarde ...</p>
</ngx-spinner>

<div class="row">
  <div class="col-12">
    <app-card cardTitle="Cadastro Programa" [options]="false">
      <div class="row">
        <div class="col-sm-12 col-xl-4 ">
          <label class="sub-title">Nome Programa</label>
          <input type="text" class="form-control" [(ngModel)]="nome" name="nome" placeholder="">
        </div>
        <div class="col-sm-12 col-xl-3 ">
          <label class="sub-title">Data Inicio </label>
          <input type="date" class="form-control" [(ngModel)]="dataInicial" name="dataInicial" placeholder="">
        </div>
        <div class="col-sm-12 col-xl-3 ">
          <label class="sub-title">Data Fim </label>
          <input type="date" class="form-control" [(ngModel)]="dataFinal" name="dataFinal" placeholder="">
        </div>

      </div>
      <div class="row">
        <div class="col-sm-12 col-xl-10 text-right">
          <br>
          <button type="button" class="btn btn-success " (click)="salvar()">SALVAR &nbsp;<i
              class="feather icon-check-circle"></i>
          </button>
          &nbsp;&nbsp;&nbsp;
          <button type="button" class="btn btn-warning " (click)="limpar()" *ngIf="programaSelecionado != null" style="margin-top: 6px;">LIMPAR &nbsp;<i
              class="feather icon-check-circle"></i>
          </button>
        </div>

      </div>



    </app-card>
  </div>
  <div class="col-12">
    <app-card cardTitle="Programas Cadastrados" blockClass="table-border-style" [options]="false">
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Descricão</th>
              <th>Data Inicio</th>
              <th>Data Fim</th>
              <th>Acão</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of arrayProgramas">
              <td>{{item.descricao }}</td>
              <td>{{item.datA_INICIO | date: "dd/MM/yyyy"}}</td>
              <td>{{item.datA_FIM | date: "dd/MM/yyyy"}}</td>
              <td>
                <button type="button" class="btn btn-icon btn-info " (click)="carregarEdicao(item)">
                  <i class="fa fa-edit"></i>
                </button>
                &nbsp;&nbsp;
                <button type="button" class="btn btn-icon btn-danger " (click)="desabilitar(item.id)">
                  <i class="fa fa-trash"></i>
                </button>

              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </app-card>
  </div>
</div>
